import { IChartData } from "./ApiRequestResponse/dashboard";
import { IDoctorHospitalDetail } from "./ApiRequestResponse/doctor";

export enum IConsultationStatus {
  TOTAL = "total_consultation",
  COMPLETED = "completed_consultation",
  UPCOMING = "upcoming_consultation",
  CANCELED = "canceled_consultation",
}

export enum ICompletedConsultationSummaryEnum {
  CONSULTATION_TYPE = "consultationType",
  APPOINTMENT_REVENUE = "appointmentRevenue",
  PATIENT_REPEAT_VISIT = "patientRepeatVisit",
  HEALTH_CATEGORY = "healthCategory",
  BOOKED_BY = "bookedBy",
  PATIENT_AGE_SPLIT = "patientAgeSplit",
}

export interface IDateRange {
  startDate: string;
  endDate: string;
  selectedValue?: string;
}

export interface ISelectOption {
  value: string;
  label: string;
}

export interface ChartData {
  count: number;
  chartData: IChartData[];
}

export interface PatientsSummaryData {
  total: ChartData;
  completed: ChartData;
  upcoming: ChartData;
  cancelled: ChartData;
}

export enum ITimePeriod {
  LAST_12_MONTHS = "last-12-months",
  LAST_6_MONTHS = "last-6-months",
  NEXT_45_DAYS = "next-45-days",
}

export interface IPatientSummaryOrIpAnalyticsState {
  dateRange: IDateRange;
  bookedBy: string | null;
  isExporting: boolean;
  selectedStat: IConsultationStatus | ICompletedConsultationSummaryEnum;
  selectedHospital: any | null;
}

export enum IPatientSummaryOrIpAnalyticsActionType {
  SET_DATE_RANGE = "SET_DATE_RANGE",
  SET_BOOKED_BY = "SET_BOOKED_BY",
  SET_EXPORTING = "SET_EXPORTING",
  SET_SELECTED_STAT = "SET_SELECTED_STAT",
  SET_SELECTED_HOSPITAL = "SET_SELECTED_HOSPITAL",
}

export type IPatientSummaryOrIpAnalyticsAction =
  | {
      type: IPatientSummaryOrIpAnalyticsActionType.SET_DATE_RANGE;
      payload: IDateRange;
    }
  | {
      type: IPatientSummaryOrIpAnalyticsActionType.SET_BOOKED_BY;
      payload: string | null;
    }
  | {
      type: IPatientSummaryOrIpAnalyticsActionType.SET_EXPORTING;
      payload: boolean;
    }
  | {
      type: IPatientSummaryOrIpAnalyticsActionType.SET_SELECTED_STAT;
      payload: IConsultationStatus | ICompletedConsultationSummaryEnum;
    }
  | {
      type: IPatientSummaryOrIpAnalyticsActionType.SET_SELECTED_HOSPITAL;
      payload: any | null;
    };

export interface IDashboardQueryParams {
  startDate?: string;
  endDate?: string;
  bookedBy?: string;
  isExport?: string;
  hospitalId?: string;
  search?: string;
}

export interface IPatientSummaryInitialState {
  isFetchPatientSummaryLoading: boolean;
  detail: PatientsSummaryData;
}

export interface IpAnalyticsInitialState {
  isFetchIpAnalyticsLoading: boolean;
  chartData: any[];
  isHospitalsLoading: boolean;
  hospitals: IDoctorHospitalDetail[];
}

export interface IDashboardInitialState {
  patientSummary: IPatientSummaryInitialState;
  ipAnalytics: IpAnalyticsInitialState;
  completedConsultationSummary: any;
}
